import React, { Component } from 'react'

import Layout from 'components/Layout.jsx'
import ResourceFileContent from 'components/ResourceFileContent'

export default class ResourceFile extends Component {
  render() {

    return (
      <Layout contentType={this.props.contentType} queryTerm={this.props.match.params.context}  lang={this.props.match.params.lang} queryType={this.props.match.params.type} queryResource={true} querySlug={this.props.match.params.slug}>
        <ResourceFileContent queryTerm={this.props.match.params.slug} lang={this.props.match.params.lang}></ResourceFileContent>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/ResourceFile.js